export default __webpack_public_path__ + "static/media/notFound.44f968b5.jpg";